module.exports = __webpack_public_path__ + "static/media/message_square.fba42284.svg";